module.exports = __webpack_public_path__ + "static/media/img1-4.fda54d8b.png";